import axios from 'axios';

const API_BASE_URL = 'https://api.goldfroeschli-kinderwelt.ch/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => {
    // Log response for debugging (remove in production)
    if (process.env.NODE_ENV === 'development') {
      console.log('API Response:', response.status, response.data);
    }
    return response;
  },
  (error) => {
    // Log error for debugging
    console.error('API Error:', error.response?.status, error.response?.data || error.message);
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login.php', credentials),
  logout: () => api.post('/auth/logout.php'),
};

// Bookings API
export const bookingsAPI = {
  list: (params) => api.get('/bookings/list.php', { params }),
  create: (data) => api.post('/bookings/admin_create.php', data),
  getDetails: (bookingId) => api.get(`/bookings/get_details.php?booking_id=${bookingId}`),
  update: (data) => api.post('/bookings/update.php', data),
  delete: (bookingId) => api.post('/bookings/delete.php', { booking_id: bookingId }),
  getTicket: (bookingId) => api.get(`/bookings/get_ticket.php?booking_id=${bookingId}`, { responseType: 'blob' }),
};

// Users API
export const usersAPI = {
  list: () => api.get('/users/list.php'),
  create: (data) => api.post('/users/create.php', data),
  update: (data) => api.post('/users/update.php', data),
  delete: (id) => api.post('/users/delete.php', { id }),
};

// Dashboard API
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats.php'),
};

// Events API
export const eventsAPI = {
  list: (all = false) => api.get(`/events/list.php${all ? '?all=true' : ''}`),
  create: (data) => api.post('/events/create.php', data),
  update: (data) => api.put('/events/update.php', data),
};

// Time Slots API
export const timeSlotsAPI = {
  list: (all = false) => api.get(`/timeslots/list.php${all ? '?all=true' : ''}`),
  create: (data) => api.post('/timeslots/create.php', data),
};

// Extras API
export const extrasAPI = {
  list: (all = false) => api.get(`/extras/list.php${all ? '?all=true' : ''}`),
  create: (data) => api.post('/extras/create.php', data),
};

export default api;
